import React, { useMemo } from "react";
import { DatePicker, LocalizationProvider } from "@mui/x-date-pickers";
import { AdapterDateFns } from "@mui/x-date-pickers/AdapterDateFns";
import isValid from "date-fns/isValid";
import isNil from "lodash/isNil";
import { dateOnlyToLocalDate } from "../../_src_shared/utils/functions/formatDate";

const DateInput = ({
  value,
  onChange,
  onBlur,
  disabled,
  onAccept,
  sx,
  ...rest
}) => {
  const convertDateToIsoString = (date) => {
    if (isNil(date) || !isValid(date)) return null;

    const y = date.getFullYear();
    const m = date.getMonth();
    const d = date.getDate();

    const utcMidnight = new Date(Date.UTC(y, m, d, 0, 0, 0, 0));
    return utcMidnight.toISOString();
  };

  // Read the stored value's calendar day with the SAME rule formatDate uses
  // (its literal leading YYYY-MM-DD), so the picker and every read-only
  // display of the field always show the same day. Parsing it with
  // `new Date()` instead read a naive backend string ("…T22:00:00", no
  // offset) as local time, then took its UTC day — a day later than
  // formatDate for any evening time.
  const isoUtcToLocalDate = (isoString) => dateOnlyToLocalDate(isoString);

  const styles = useMemo(() => {
    return {
      ".MuiButtonBase-root": {
        borderRadius: "0px",
        borderLeft: "1px solid #dddddd",
        marginRight: "-14px",
      },
      ...sx,
    };
  }, [sx]);

  return (
    <LocalizationProvider dateAdapter={AdapterDateFns}>
      <DatePicker
        disabled={disabled}
        sx={styles}
        value={isoUtcToLocalDate(value)}
        onAccept={(date) => {
          if (isNil(onAccept)) return;
          onAccept(convertDateToIsoString(date));
        }}
        onChange={(date) => {
          onChange(convertDateToIsoString(date));
        }}
        slotProps={{
          textField: { fullWidth: true, onBlur, ...rest },
          // Keep the calendar above high-z-index surfaces (e.g. the drilldown
          // sidebar pane at zIndex 13000), otherwise it opens behind them.
          popper: { sx: { zIndex: 13500 } },
          desktopPaper: {
            sx: {
              borderRadius: "14px",
              button: { fontSize: "14px" },
            },
          },
        }}
      />
    </LocalizationProvider>
  );
};

export default DateInput;

// import React, { useMemo } from "react";

// import { DatePicker, LocalizationProvider } from "@mui/x-date-pickers";
// import { AdapterDateFns } from "@mui/x-date-pickers/AdapterDateFns";

// import isValid from "date-fns/isValid";
// import isNil from "lodash/isNil";

// const DateInput = ({
//   value,
//   onChange,
//   onBlur,
//   disabled,
//   onAccept,
//   sx,
//   ...rest
// }) => {
//   const convertDateToIsoString = (isoString) => {
//     if (isNil(isoString)) {
//       return null;
//     }
//     let date = new Date(isoString);
//     if (date instanceof Date && !isNaN(date)) {
//       return date.toISOString();
//     }
//     return null;
//   };

//   const styles = useMemo(() => {
//     return {
//       ".MuiButtonBase-root": {
//         borderRadius: "0px",
//         borderLeft: "1px solid #dddddd",
//         marginRight: "-14px",
//       },
//       ...sx,
//     };
//   }, [sx]);

//   return (
//     <LocalizationProvider dateAdapter={AdapterDateFns}>
//       <DatePicker
//         disabled={disabled}
//         sx={styles}
//         value={isValid(new Date(value)) ? new Date(value) : null}
//         onAccept={(date) => {
//           if (isNil(onAccept)) {
//             return;
//           }
//           if (isValid(date)) {
//             onAccept(convertDateToIsoString(date));
//           } else {
//             onAccept(null);
//           }
//         }}
//         onChange={(date) => {
//           if (isValid(date)) {
//             onChange(convertDateToIsoString(date));
//           } else {
//             onChange(null);
//           }
//         }}
//         slotProps={{
//           textField: { fullWidth: true, onBlur, ...rest },
//           desktopPaper: {
//             sx: {
//               borderRadius: "14px",
//               button: {
//                 fontSize: "14px",
//               },
//             },
//           },
//         }}
//       />
//     </LocalizationProvider>
//   );
// };

// export default DateInput;
